export enum ImageSize {
    Thumbnail = 160,
    XS = 240,
    S = 360,
    M = 540,
    L = 720,
    XL = 1080,
    XXL = 1440
}

export function getImageAsset(widthInPx: number, imageUrl: string) {
    let imageWidth : number;
    if (widthInPx < ImageSize.Thumbnail) {
        imageWidth = ImageSize.Thumbnail
    } else if (widthInPx < ImageSize.XS) {
        imageWidth = ImageSize.XS
    } else if (widthInPx < ImageSize.S) {
        imageWidth = ImageSize.S
    } else if (widthInPx < ImageSize.M) {
        imageWidth = ImageSize.M
    } else if (widthInPx < ImageSize.L) {
        imageWidth = ImageSize.L
    } else if (widthInPx < ImageSize.XL) {
        imageWidth = ImageSize.XL
    } else {
        imageWidth = ImageSize.XXL
    }
    
    return `${imageUrl}?width=${imageWidth}&quality=90&upscale=false`;
}